import { ComponentType, SVGProps } from 'react';

import { keyBy } from '@/utils/util-functions';
import MachineDataTagIcon from '@/comp/common/icons/MachineDataTagIcon';
import ControllerFrontIcon from '@/comp/common/icons/ControllerFrontIcon';
import ControllerBackIcon from '@/comp/common/icons/ControllerBackIcon';
import ElectricalCabinetIcon from '@/comp/common/icons/ElectricalCabinetIcon';
import IncomingWiringIcon from '@/comp/common/icons/IncomingWiringIcon';
import PictureIcon from '@/comp/common/icons/PictureIcon';

import { CompressorImageTags, OtherDeviceImageTags, SensorImageTags } from './CompressorImageTags.enum';
import { compressorTypes, DeviceType, sensorTypes } from './deviceTypeEnum';
import { isNil } from 'lodash';

export type ImageTagData = {
  tag: ImageTags;
  Svg: ComponentType<SVGProps<SVGSVGElement>>;
  translationKey: string;
};

export type ImageTags = CompressorImageTags | SensorImageTags | OtherDeviceImageTags;

export const COMPRESSOR_IMAGE_TAG_DATA: ImageTagData[] = [
  {
    tag: CompressorImageTags.MachineDataTag,
    Svg: MachineDataTagIcon,
    translationKey: 'uploadImageTagMachineDataTag',
  },
  {
    tag: CompressorImageTags.ControllerFront,
    Svg: ControllerFrontIcon,
    translationKey: 'uploadImageTagControllerFront',
  },
  {
    tag: CompressorImageTags.ControllerBack,
    Svg: ControllerBackIcon,
    translationKey: 'uploadImageTagControllerBack',
  },
  {
    tag: CompressorImageTags.ElectricalCabinet,
    Svg: ElectricalCabinetIcon,
    translationKey: 'uploadImageTagElectricalCabinet',
  },
  {
    tag: CompressorImageTags.IncomingWiring,
    Svg: IncomingWiringIcon,
    translationKey: 'uploadImageTagIncomingWiring',
  },
  {
    tag: CompressorImageTags.Other,
    Svg: PictureIcon,
    translationKey: 'uploadImageTagOther',
  },
];

export const SENSOR_IMAGE_TAG_DATA: ImageTagData[] = [
  {
    tag: SensorImageTags.PipeFocused,
    Svg: PictureIcon,
    translationKey: 'uploadImageTagPipeFocused',
  },
  {
    tag: SensorImageTags.PipePanoramaVideo,
    Svg: PictureIcon,
    translationKey: 'uploadImageTagPipePanoramaVideo',
  },
  {
    tag: SensorImageTags.Sensor,
    Svg: PictureIcon,
    translationKey: 'uploadImageTagSensor',
  },
  {
    tag: SensorImageTags.Other,
    Svg: PictureIcon,
    translationKey: 'uploadImageTagOther',
  },
];

export const OTHER_DEVICE_IMAGE_TAG_DATA: ImageTagData[] = [
  {
    tag: OtherDeviceImageTags.Other,
    Svg: PictureIcon,
    translationKey: 'uploadImageTagOther',
  },
];

const ALL_DEVICES_IMAGE_TAG_DATA = [
  ...COMPRESSOR_IMAGE_TAG_DATA,
  ...SENSOR_IMAGE_TAG_DATA,
  ...OTHER_DEVICE_IMAGE_TAG_DATA,
];

export const getImageTagDataByDeviceType = (deviceType: DeviceType): ImageTagData[] => {
  if (compressorTypes.includes(deviceType) || isNil(deviceType)) {
    return COMPRESSOR_IMAGE_TAG_DATA;
  } else if (sensorTypes.includes(deviceType)) {
    return SENSOR_IMAGE_TAG_DATA;
  }
  return OTHER_DEVICE_IMAGE_TAG_DATA;
};

export const COMPRESSOR_IMAGE_TAG_DIRECTORY_DATA = keyBy(ALL_DEVICES_IMAGE_TAG_DATA, 'tag');
